import { render, staticRenderFns } from "./QuotationDialog.component.vue?vue&type=template&id=dfd6adc6&scoped=true"
import script from "./QuotationDialog.component.vue?vue&type=script&lang=js"
export * from "./QuotationDialog.component.vue?vue&type=script&lang=js"
import style0 from "./QuotationDialog.component.vue?vue&type=style&index=0&id=dfd6adc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfd6adc6",
  null
  
)

export default component.exports